import { render } from "./NavBarUserComp.vue?vue&type=template&id=6a06afaa"
import script from "./NavBarUserComp.vue?vue&type=script&lang=js"
export * from "./NavBarUserComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__